import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Typography,
  Chip,
  CircularProgress,
  Box,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import BusinessIcon from "@mui/icons-material/Business";
import EmailIcon from "@mui/icons-material/Email";
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import { useApiContext } from "../../../Utils/ApiContext/ApiContext";

const AllDoctorsList = ({onDoctorClick}) => {
  const { doctors, loading } = useApiContext();
  const [searchTerm, setSearchTerm] = useState("");

  // Filter doctors based on search input
  const filteredDoctors = doctors?.filter((doctor) =>
    `${doctor.fname} ${doctor.lname} ${doctor.username}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  return (
    <Box sx={{ p: 2 }}>
      <TextField
        label="Search by Name or Username"
        variant="outlined"
        fullWidth
        size="small"
        onChange={(e) => setSearchTerm(e.target.value)}
        sx={{ mb: 2 }}
      />

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
          <Table>
            {/* Table Head */}
            <TableHead>
              <TableRow sx={{ backgroundColor: "#05b6b3" }}>
                <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>ID</TableCell>
                <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Username</TableCell>
                <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>First Name</TableCell>
                <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Last Name</TableCell>
                <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Facility</TableCell>
                <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Facility ID</TableCell>
                <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Email</TableCell>
                <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Contact</TableCell>
              </TableRow>
            </TableHead>

            {/* Table Body */}
            <TableBody>
              {filteredDoctors?.length > 0 ? (
                filteredDoctors.map((doctor) => (
                  <TableRow key={doctor.id} hover onClick={() => onDoctorClick(doctor)}>
                    <TableCell>{doctor.id}</TableCell>

                    {/* Username in MUI Chip with Person Icon */}
                    <TableCell>
                      <Chip
                        icon={<PersonIcon />}
                        label={doctor.username}
                        color="primary"
                        variant="outlined"
                      />
                    </TableCell>

                    <TableCell>{doctor.fname}</TableCell>
                    <TableCell>{doctor.lname}</TableCell>

                    {/* Facility Name with Business Icon */}
                    <TableCell>
                      <Chip
                        icon={<BusinessIcon />}
                        label={doctor.facility}
                        color="success"
                        variant="outlined"
                      />
                    </TableCell>

                    <TableCell>{doctor.facility_id}</TableCell>

                    {/* Email with Email Icon */}
                    <TableCell>
                      {doctor.email ? (
                        <Chip icon={<EmailIcon />} label={doctor.email} color="info" variant="outlined" />
                      ) : (
                        "N/A"
                      )}
                    </TableCell>
                    <TableCell>
                      {doctor.phonecell ? (
                        <Chip icon={<LocalPhoneIcon />} label={doctor.phonecell} color="info" variant="outlined" />
                      ) : (
                        "N/A"
                      )}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    <Typography variant="body1" color="textSecondary">
                      No doctors found.
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default AllDoctorsList;
